import { useState } from 'react';
import { Fields } from '../../../utils/Fields';
import classNames from 'classnames';
import { Search } from 'react-feather';
var classes = {
    inputGroup: {
        base: 'flex items-center gap-4 px-4 w-full relative rounded-md border border-gray-300 text-base transition-colors focus:border-2 focus:border-brand-dark',
        error: 'border-alert-danger focus:border-alert-danger',
    },
    input: 'flex-1 appearance-none focus:outline-none placeholder-gray-500 rounded-md py-[14px]',
    icon: 'text-gray-900',
};
var SearchInput = function (_a) {
    var onChange = _a.onChange, onSubmit = _a.onSubmit, className = _a.className, placeholder = _a.placeholder;
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var handleChange = function (e) {
        setValue(e.currentTarget.value);
        onChange(e.currentTarget.value);
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        onSubmit(value);
    };
    return (<div className={classNames('flex w-full flex-col', className)}>
      <div className={classNames(classes.inputGroup.base)}>
        <input name="search" className={classes.input} type={Fields.TEXT} placeholder={placeholder} onChange={function (e) { return handleChange(e); }} onKeyPress={function (e) {
            e.key === 'Enter' && handleSubmit(e);
        }}/>
        <Search className={classes.icon} size={18} onClick={function (e) { return handleSubmit(e); }}/>
      </div>
    </div>);
};
export default SearchInput;
